/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 注意事項ダイアログ
 *
 * @author dvinhthai
 * @copyright Copyright 2025 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<transition name="modal">
  <div class="fc-chat-caution-confirm-dialog">
    <div class="modal-wrapper">
      <div class="modal-container fc-distribution-message-wrapper">
        <div class="modal-header"><b>重要なご連絡</b></div>
        <div class="modal-header fc-text-message fc-distribution-message">{{message}}</div>
        <div class="message-timestamp">{{messageSendDate}}</div>
        <div class="modal-button">
          <el-button type="primary" @click="onHideForever">以後表示しない</el-button>
          <el-button @click="close">閉じる</el-button>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import {
  Button
} from 'element-ui'
import DateUtil from '@/utils/DateUtil'
import ServiceUtil from '@/utils/ServiceUtil'
import DialogUtil from '@/utils/DialogUtil'

export default {
  components: {
    'el-button': Button
  },
  data() {
    return {
      /**
       * SNSメッセージ更新キー
       * @type {Object}
       */
       extMessageKey: null,
      /**
       * メッセージ
       * @type {Object}
       */
      message: null,
      /**
       * 送信日時
       * @type {Date}
       */
      sendDate: null
    }
  },
  computed: {
    messageSendDate() {
      return DateUtil.formatDate(new Date(this.sendDate), this.$t('MM/DD hh:mm'))
    }
  },
  methods: {
    /**
     * 以後表示しない
     */
    onHideForever() {
      var fastchatMessageDto = {
        extMessageKey: this.extMessageKey
      }
      ServiceUtil.request('modifyNotificationFlg', fastchatMessageDto, {
        success: (responseData) => {
          this.close()
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode)
        }
      })
    },
    /**
     * 閉じる
     */
    close() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.modal-container {
  width: 80%;
  max-width: 500px;
}
.message-timestamp {
  font-size: 10px;
  padding-right: 15px;
  padding-left: 15px;
}
.fc-text-message {
  margin: 10px 0;
  white-space: pre-line;
  word-break: break-word;
}
.modal-button {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/dialog/FcDistributionMessageDialog.vue